import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { CompoundEntityRef, Entity } from '@backstage/catalog-model';

export const useFetchEntityByRef = (
  entityRef: string | CompoundEntityRef,
): {
  loading: boolean;
  value: Entity | undefined;
  error: Error | undefined;
} => {
  const catalogApi = useApi(catalogApiRef);

  const fetchEntityByRef = async () => {
    return await catalogApi.getEntityByRef(entityRef);
  };

  const { loading, value, error } = useAsync(fetchEntityByRef, []);

  return { loading, value, error };
};
